module.exports = "/_next/static/images/offers3-2x-88a2d7a628676c3f1bc7217a89086669.jpg.webp";